<template>
  <a-card :bordered="false">
    <!-- 検索区域-begin -->
    <search-area
      ref="SearchArea"
      :rowKeySize="this.selectedRowKeys.length"
      batchType="4"
      parent="AdminUnactiveModal"
      @searchQuery="searchQuery(false, false)"
      @updateQueryParam="updateQueryParam"
      @batchAction="batchAction"
    ></search-area>
    <!-- 検索区域-end -->

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        class="action"
        rowKey="processInstanceId"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        @change="handleTableChange"
        tableLayout="auto"
      >
        <!-- 申請時間 -->
        <div slot="startDate" slot-scope="text, record">
          <span>
            {{ moment(record.startDate).format('YYYY-MM-DD') }}
          </span>
          <span class="note">
            {{ moment(record.startDate).format(' HH:mm:ss') }}
          </span>
        </div>

        <!-- 最近更新時間 -->
        <div slot="endDate" slot-scope="text, record">
          <span>
            {{ moment(record.endDate).format('YYYY-MM-DD') }}
          </span>
          <span class="note">
            {{ moment(record.endDate).format(' HH:mm:ss') }}
          </span>
        </div>

        <!-- タスク -->
        <div slot="task" slot-scope="text, record">
          <TaskColumn :record="record" :key="refresh"></TaskColumn>
        </div>

        <!-- ステータス -->
        <span slot="taskStatus" slot-scope="text, record">
          <a-tag color="green" v-if="record.taskStatus == 'disp.flow.save'">{{ $t(record.taskStatus) }}</a-tag>
          <a-tag color="purple" v-if="record.taskStatus == 'disp.flow.applyWait'">{{ $t(record.taskStatus) }}</a-tag>
          <a-tag color="orange" v-else-if="record.taskStatus == 'disp.flow.approveWait'">{{
            $t(record.taskStatus)
          }}</a-tag>
          <a-tag color="cyan" v-else-if="record.taskStatus == 'disp.flow.keep'">{{ $t(record.taskStatus) }}</a-tag>
          <a-tag color="blue" v-else-if="record.taskStatus == 'disp.flow.freeze'">{{ $t(record.taskStatus) }}</a-tag>
        </span>

        <!-- 操作 -->
        <span slot="action" slot-scope="text, record">
          <span v-if="!record.freezeFlag">
            <!-- 処理者追加 -->
            <a @click="handleCandidateAdd(record.processInstanceId, record.endDateTimestamp)">{{
              $t('disp.flow.candidateAdd')
            }}</a>
            <!-- 取消 -->
            <a-divider type="vertical" />
            <a-popconfirm
              :title="$t('msg.flow.confirm.cancel')"
              @confirm="() => handleCancel(record.processInstanceId, record.endDateTimestamp)"
            >
              <a>{{ $t('disp.flow.cancel') }}</a>
            </a-popconfirm>
            <a-divider type="vertical" />
          </span>
          <a @click="handleOpen(record)">{{ $t('disp.flow.detail') }}</a>
          <a-divider type="vertical" />
          <a @click="handleHistory(record.processInstanceId, record.processDefinitionName)">{{
            $t('disp.flow.history')
          }}</a>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- ユーザツリーモーダル -->
    <select-user-tree-modal ref="selectUserTreeModal" @emit="emit"></select-user-tree-modal>

    <!-- 履歴モーダル -->
    <track-modal ref="TrackModal"></track-modal>

    <!-- 詳細モーダル -->
    <apply-modal ref="ApplyModal"></apply-modal>

    <!-- コメントモーダル：コメントフォームを載せる -->
    <comment-modal ref="CommentModal" @ok="searchQuery(false, false)"></comment-modal>
  </a-card>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import { flowMixin } from '@/mixins/flowMixin'
import { putAction, postAction, getAction } from '@/api/manage'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import SearchArea from './SearchArea'
import SelectUserTreeModal from '@/views/k00/k0014/modules/SelectUserTreeModal'
import TrackModal from './TrackModal'
import CommentModal from '@/views/k00/k0011/modules/CommentModal'
import TaskColumn from '@/views/k00/k0011/modules/TaskColumn'

export default {
  name: 'AdminUnactiveModal',
  mixins: [tableMixin, flowMixin],
  components: {
    JDictSelectTag,
    SearchArea,
    SelectUserTreeModal,
    TrackModal,
    CommentModal,
    TaskColumn,
  },
  data() {
    return {
      description: '非活性案件・進行中',
      showLoadingBySearch: true,
      isBatchAction: false,
      selectUserList: [],
      processInstanceId: '',
      endDateTimestamp: '',
      refresh: Date.parse(new Date()),
      // テーブルタイトル
      columns: [
        {
          title: this.$t('disp.flow.applyId'),
          //align: 'center',
          //width: 91,
          //fixed: 'left',
          dataIndex: 'processInstanceId',
          customRender: this.renderProcessInstanceId,
        },
        {
          title: this.renderApplyNameHeader,
          dataIndex: 'processDefinitionName',
          customRender: this.renderApplyName,
        },
        {
          title: this.$t('disp.flow.starter'),
          align: 'center',
          width: 91,
          customRender: this.renderStarter,
        },
        {
          title: this.$t('disp.flow.starterOrg'),
          align: 'left',
          // width: 180,
          dataIndex: 'starterDepartName',
          customRender: this.renderDepartName,
        },
        {
          title: this.$t('disp.flow.startDate'),
          align: 'left',
          dataIndex: 'startDate',
          //scopedSlots: { customRender: 'startDate' },
          customRender: this.renderDate,
        },
        {
          title: this.$t('disp.flow.lastUpdateDate'),
          align: 'left',
          dataIndex: 'endDate',
          //scopedSlots: { customRender: 'endDate' },
          customRender: this.renderDate,
        },
        {
          title: this.$t('disp.flow.task'),
          scopedSlots: { customRender: 'task' },
        },
        // {
        //   title: this.$t('disp.flow.candidate'),
        //   align: 'center',
        //   scopedSlots: { customRender: 'candidate' }
        // },
        {
          title: this.$t('disp.status'),
          align: 'center',
          width: 91,
          //fixed: 'right',
          scopedSlots: { customRender: 'taskStatus' },
        },
        {
          title: this.$t('disp.operation'),
          dataIndex: 'action',
          align: 'center',
          //width: 240,
          //fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/flow/adminUnactive/list',
        candidateAdd: '/flow/processInstance/candidateAdd',
        cancel: '/flow/processInstance/cancel',
      },
    }
  },
  methods: {
    updateQueryParam() {
      this.queryParam = this.$refs.SearchArea ? this.$refs.SearchArea.queryParam : {}
    },
    tagColor(task) {
      if (task.taskActive) {
        return 'blue'
      } else {
        return 'blue'
      }
    },
    tagName(user) {
      return user.realname
    },
    // 処理者追加
    handleCandidateAdd(processInstanceId, endDateTimestamp) {
      this.isBatchAction = false
      this.processInstanceId = processInstanceId
      this.endDateTimestamp = endDateTimestamp
      this.$refs.selectUserTreeModal.params.multiFlg = '1'
      this.$refs.selectUserTreeModal.params.departFlg = '1'
      this.$refs.selectUserTreeModal.params.selectUserList = this.selectUserList
      this.$refs.selectUserTreeModal.loadDepart()
      this.$refs.selectUserTreeModal.visible = true
    },
    // 取消
    handleCancel(processInstanceId, endDateTimestamp) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.cancel, { processInstanceId: processInstanceId, endDateTimestamp: endDateTimestamp })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, false)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleOpen(record) {
      // 0 下記以外
      // 1 申請ポータル
      // 2 一時保存一覧
      // 3 未処理一覧
      // 4 処理済一覧・進行中案件 or 申請案件一覧・進行中案件
      // 5 処理済一覧・終了案件 or 申請案件一覧・終了案件
      // 6 処理済一覧・非活性案件
      this.$refs.ApplyModal.popupFrom = '6'

      this.$refs.ApplyModal.title = record.processDefinitionName
      this.$refs.ApplyModal.component = record.component
      this.$refs.ApplyModal.procInstId = record.processInstanceId
      this.$refs.ApplyModal.taskId = record.id
      this.$refs.ApplyModal.status = record.taskStatus

      this.$refs.ApplyModal.handleOpen()
    },
    handleHistory(processInstanceId, title) {
      this.$refs.TrackModal.open(processInstanceId, title)
    },
    callbackAfterSearchQuery() {
      this.refresh++
    },
    emit(rows) {
      if (rows.length == 0) {
        return
      }
      if (this.loading) {
        return
      } else {
        this.loading = true
      }
      let userIds = ''
      for (let item of rows) {
        userIds += item.value + ','
      }

      if (this.isBatchAction) {
        var arr = []
        this.selectionRows.forEach((val) => {
          if (!val.freezeFlag) {
            arr.push(val)
          }
        })

        let batchInfo = []
        const batchUserAddAction = (val, userIds) => {
          if (!val) {
            return
          }
          return new Promise((resolve) => {
            postAction(this.url.candidateAdd, {
              processInstanceId: val.processInstanceId,
              endDateTimestamp: val.endDateTimestamp,
              userIds: userIds,
            })
              .then((res) => {
                resolve(res)
              })
              .catch((err) => {})
          })
        }
        arr.forEach((val) => batchInfo.push(batchUserAddAction(val, userIds)))
        Promise.allSettled(batchInfo)
          .then((res) => {
            if (res && res.length != 0) {
              this.$message.success(this.$t(res[0].value.message))
              this.loading = false
              this.searchQuery(false, false)
            }
          })
          .catch((err) => {})
          .finally(() => {
            // ローディング終了
            if (this.loading) {
              this.loading = false
            }
          })
      } else {
        // 一括処理以外の場合
        postAction(this.url.candidateAdd, {
          processInstanceId: this.processInstanceId,
          endDateTimestamp: this.endDateTimestamp,
          userIds: userIds,
        })
          .then((res) => {
            if (res.success) {
              this.$message.success(this.$t(res.message))
              this.searchQuery(true, false)
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>
